// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"238":"23ba50e8","448":"d1ef4cf3","607":"2618af7f","639":"aaecdcc5","842":"04fe84f2"}[chunkId] + ".chunk.js";
};